import React, { useState } from 'react'
import { isEmpty } from '../../../services/common'
import {
    Address,
    BlockCase,
    CanHelpMe,
    Case,
    Chapter,
    Complement,
    Description,
    EmailAddress,
    Example,
    Fax,
    File,
    Folder,
    FooterTopDropdownLinks,
    GeneralsInformations,
    Group,
    GuidedResearch,
    Hourly,
    IllustratedContent,
    Image,
    Information,
    Introduction,
    Item,
    List,
    ListOfSituations,
    LocalSearch,
    LocalService,
    OnlineService,
    Phone,
    Problematic,
    Problematics,
    Question,
    Quiz,
    RelatedFile,
    RelatedFileItem,
    Source,
    SubChapter,
    SubFolder,
    Table,
    TimeSlots,
    UnderTheme,
    Video,
    Warning,
    WebLink,
    WebSite,
    WhereToContact,
    WhereToContactItem,
} from '../../fiche'
import Definition from '../../fiche/definition/Definition'
import { Credit, Date, ImageIllustration, OnTitle, RefNew, TitleNews } from '../../news'
import Paragraph from '../paragraph/Paragraph'
import TitleFloating from '../title/TitleFloating'
import TitleParser from '../title/TitleParser'

const Parser = ({
    type,
    isPersonnalizedLocal,
    content_block = [],
    attributes,
    verification_date,
    contributor,
    viewGeneralInformation,
    setViewGeneralInformation,
    parent,
    position,
}) => {
    const [choice, setChoice] = useState(null)

    const blocks = React.useMemo(() => {
        if (isEmpty(content_block)) return []

        return content_block.map((block, index) => {
            if (!('ID' in block)) {
                block.ID = `block-${block.block}-${index}`
            }

            switch (block.block) {
                case 'Paragraphe':
                case 'Texte':
                    return <Paragraph key={block?.ID} attributes={attributes} block={block} />
                case 'RefActualite':
                    return <RefNew key={block?.ID} block={block} position={position} />
                case 'ImageIllustration':
                    return <ImageIllustration key={block?.ID} block={block} position={position} />
                case 'SurTitre':
                    return <OnTitle key={block?.ID} block={block} />
                case 'Credits':
                    return <Credit key={block?.ID} block={block} />
                case 'Date':
                    return <Date key={block?.ID} block={block} />
                case 'Groupe':
                    return <Group key={block?.ID} attributes={attributes} block={block} />
                case 'Introduction':
                    if (block?.style === 'root') {
                        return (
                            <Introduction
                                key={block?.ID}
                                contributor={contributor}
                                date={verification_date}
                                block={block}
                            />
                        )
                    }
                    return <Introduction key={block?.ID} attributes={attributes} block={block} />
                case 'Titre':
                    if (position) {
                        return <TitleNews key={block?.ID} block={block} />
                    } else {
                        return (
                            <TitleParser
                                type={type}
                                key={block?.ID}
                                attributes={attributes}
                                block={block}
                            />
                        )
                    }

                case 'TitreFlottant':
                    return <TitleFloating key={block?.ID} block={block} />
                case 'Chapitre':
                    return <Chapter key={block?.ID} block={block} />
                case 'SousChapitre':
                    return <SubChapter key={block?.ID} block={block} />
                case 'SousTheme':
                    return <UnderTheme key={block?.ID} block={block} />
                case 'Dossier':
                    return <Folder key={block?.ID} block={block} />
                case 'Avertissement':
                    return <Warning key={block?.ID} block={block} />
                case 'QuiPeutMAider':
                    return <CanHelpMe key={block?.ID} block={block} />
                case 'VoirAussi':
                case 'QuestionReponse':
                case 'Reference':
                    return <FooterTopDropdownLinks key={block?.ID} block={block} index={index} />
                case 'FicheLiee':
                    return <RelatedFile key={block?.ID} block={block} />
                case 'FicheLieeItem':
                    return <RelatedFileItem key={block?.ID} block={block} />
                case 'ServiceEnLigne':
                    if (block.style === 'card') {
                        return (
                            <FooterTopDropdownLinks key={block?.ID} block={block} index={index} />
                        )
                    }
                    return <OnlineService key={block?.ID} block={block} />
                case 'Liste':
                    return <List key={block?.ID} block={block} />
                case 'Definition':
                    return <Definition key={block?.ID} block={block} />
                case 'Video':
                    return <Video key={block?.ID} block={block} />
                case 'RechercheGuidee':
                    return <GuidedResearch key={block?.ID} block={block} />
                case 'Problematiques':
                    return <Problematics key={block?.ID} block={block} index={index} />
                case 'Problematique':
                    return <Problematic key={block?.ID} block={block} index={index} />
                case 'Branche':
                    return <Problematic key={block?.ID} block={block} index={index} />
                case 'Item':
                    return <Item key={block?.ID} block={block} />
                case 'Complement':
                    return <Complement key={block?.ID} block={block} />
                case 'ANoter':
                case 'ASavoir':
                case 'Attention':
                case 'Rappel':
                    return <Information key={block?.ID} block={block} />
                case 'Tableau':
                    return <Table key={block?.ID} block={block} />
                case 'Exemple':
                    return <Example key={block?.ID} block={block} />
                case 'ListeSituations':
                    return <ListOfSituations key={block?.ID} block={block} />
                case 'BlocCas':
                    return <BlockCase key={block?.ID} block={block} />
                case 'Cas':
                    return <Case key={block?.ID} block={block} />
                case 'OuSAdresser':
                    return <WhereToContact key={block?.ID} block={block} />
                case 'OuSAdresserItem':
                    return (
                        <WhereToContactItem
                            isPersonnalizedLocal={isPersonnalizedLocal}
                            key={block?.ID}
                            block={block}
                        />
                    )
                case 'ServiceLocal':
                    return <LocalService key={block?.ID} block={block} index={index} />
                case 'RechercheLocalForm':
                    return <LocalSearch key={block?.ID} block={block} attributes={attributes} />
                case 'Adresse':
                    return <Address key={block?.ID} block={block} />
                case 'Telephone':
                    return <Phone key={block?.ID} block={block} />
                case 'Horaire':
                    return <Hourly key={block?.ID} block={block} />
                case 'Telecopie':
                    return <Fax key={block?.ID} block={block} />
                case 'PlageHoraire':
                    return <TimeSlots key={block?.ID} block={block} />
                case 'SiteInternet':
                    return <WebSite key={block?.ID} block={block} />
                case 'LienWeb':
                    return (
                        <WebLink
                            key={block?.ID}
                            block={block}
                            date={verification_date}
                            contributor={contributor}
                        />
                    )
                case 'AdresseCourriel':
                    return <EmailAddress key={block?.ID} block={block} />
                case 'ContenuIllustre':
                    return <IllustratedContent key={block?.ID} block={block} />
                case 'Image':
                    return <Image key={block?.ID} block={block} />
                case 'Description':
                    return <Description key={block?.ID} block={block} />
                case 'SousDossier':
                    return <SubFolder key={block.ID} block={block} />
                case 'Fiche':
                    return <File key={block?.ID} block={block} parent={parent} />
                case 'Source':
                    return <Source key={block?.ID} block={block} />
                case 'Questionnaire':
                    return <Quiz key={block?.ID} block={block} />
                case 'Question':
                    return (
                        <Question
                            key={block?.ID}
                            block={block}
                            setChoice={setChoice}
                            choice={choice}
                        />
                    )
                case 'InformationsGenerales':
                    return (
                        <GeneralsInformations
                            key={block?.ID}
                            viewGeneralInformation={viewGeneralInformation}
                            setViewGeneralInformation={setViewGeneralInformation}
                            block={block}
                        />
                    )
                default:
                    return null
            }
        })
    }, [
        content_block,
        attributes,
        verification_date,
        contributor,
        viewGeneralInformation,
        setViewGeneralInformation,
        parent,
        position,
        choice,
    ])

    return <div>{blocks}</div>
}
export default Parser
